import { RootState } from "../../store";

export const selectBackup = (state: RootState) => state.backup;
